<template>
  <div class="black-inputs services-day">
    <el-row>
      <el-row class="dateChooser" :gutter="5">
        <el-input v-if="!isEditing" class="eventName" v-model="name"
          placeholder="Nom de l'évènement (visible par vous uniquement)"></el-input><br><br>
        <el-input class="eventName" v-model="title" placeholder="Titre de l'évènement"></el-input><br><br>
        <el-col v-if="getLink !== ''" :span="18" class="screen-fake-input">{{ getLink }}</el-col>
        <el-input v-model="desc" :autosize="{ minRows: 3 }" type="textarea"
          placeholder="Description de l'évènement"></el-input>
      </el-row>
      <el-row class="dateChooser" :gutter="5">
        <el-col :span="24">
          <el-date-picker class="datePicker" ref="picker" v-model="dates" type="daterange" @change="cleanDays()"
            range-separator="au" start-placeholder="Date de début" end-placeholder="Date de fin" format="dd/MM/yyyy" />
        </el-col>
      </el-row>
    </el-row>
    <el-row>
      <el-checkbox-group v-model="daySelected">
        <el-checkbox-button v-for="day in labelDays" :label="day" :key="day">{{ day }}</el-checkbox-button>
      </el-checkbox-group>
    </el-row>
    <el-row v-if="event">
      <el-col :span="24">
        <div class="services-line">
          <div class="services-line-centered">
            <div class="services-line-container">
              <!-- left -->
              <div class="services-line-service" style='left:0'>
                <div class="services-line-point">
                  <span v-if="event && event.capacityIntervalTab &&
                    event.capacityIntervalTab.length > 0 && haveCapacityMin()">
                    <el-popover placement="top" trigger="click" class="black-inputs">
                      <div class="black-inputs">
                        <el-input-number @change="checkIntervalNull(0)" :min="-1"
                          v-model="event.capacityIntervalTab[0].capacity"></el-input-number>
                      </div>
                      <div slot="reference" class="clickBox">{{ event.capacityIntervalTab[0].capacity }}</div>
                    </el-popover>
                  </span>
                </div>
                <div class="services-line-hour">{{ event.opening }}</div>
              </div>
              <!-- range -->
              <div class="services-line-service" v-for="hInter in getNumberOfIntervalEventsDyna(event)" :key="hInter.id"
                :style="{ left: ((hInter.id) / (getNumberOfIntervalEventsDyna(event).length + 1)) * 100 + '%' }">
                <div v-if="event && event.capacityIntervalTab &&
                  event.capacityIntervalTab[hInter.id] &&
                  event.capacityIntervalTab.length > 0">
                  <div class="services-line-point">
                    <el-popover placement="top" trigger="click" class="black-inputs">
                      <div class="black-inputs">
                        <el-input-number @change="checkIntervalNull(hInter.id)" :min="-1"
                          v-model="event.capacityIntervalTab[hInter.id].capacity"></el-input-number>
                      </div>
                      <div slot="reference" class="clickBox">{{ event.capacityIntervalTab[hInter.id].capacity }}</div>
                    </el-popover>
                  </div>
                  <div class="services-line-minihour">{{ hInter.hour }}</div>
                </div>
                <div v-else>
                  <div class="services-line-minipoint"></div>
                  <div class="services-line-minihour">{{ hInter.hour }}</div>
                </div>
              </div>
              <!-- right -->
              <div class="services-line-service" style='left:98%'>
                <div class="services-line-point">
                  <span v-if="event && event.capacityIntervalTab &&
                    event.capacityIntervalTab.length > 0 && haveCapacityMax()">
                    <el-popover placement="top" trigger="click" class="black-inputs">
                      <div class="black-inputs">
                        <el-input-number @change="checkIntervalNull(event.capacityIntervalTab.length - 1)" :min="-1"
                          v-model="event.capacityIntervalTab[event.capacityIntervalTab.length - 1].capacity"></el-input-number>
                      </div>
                      <div slot="reference" class="clickBox">
                        {{ event.capacityIntervalTab[event.capacityIntervalTab.length - 1].capacity }}</div>
                    </el-popover>
                  </span>
                </div>
                <div class="services-line-hour">{{ event.closing }}</div>
              </div>
              <div class="services-line-bckg"></div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-form v-if="event" class="services-day-parameters" ref="event" :model="event">
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="Ouverture">
            <el-time-select :value="event.opening" @input="changeThenCallInputInit($event, 'opening')" :picker-options="{
              start: '05:30',
              step: '00:15',
              end: '23:30'
            }" :clearable="false" placeholder="Select time">
            </el-time-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Fermeture">
            <el-time-select :value="event.closing" @input="changeThenCallPopulateCT($event, 'closing')" :picker-options="{
              start: '05:30',
              step: '00:15',
              end: '23:30'
            }" :clearable="false" placeholder="Select time">
            </el-time-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Capacité">
            <el-input-number :value="event.capacity" @input="changeSimple($event, 'capacity')" :min="1">
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Capacité par tranche horaire">
            <el-input-number :value="event.capacityIntervalMain" :key="event.capacityIntervalMain"
              @input="changeThenCallPopulateCT($event, 'capacityIntervalMain')" :min="0">
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Durée d'un service">
            <el-time-select :value="event.lenghtService" @input="changeSimple($event, 'lenghtService')" :picker-options="{
              start: '00:30',
              step: '00:30',
              end: '3:30'
            }" :clearable="false" placeholder="Select time">
            </el-time-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="event.nbServices < 2">
          <el-form-item label="Première heure pour la prise de réservation">
            <el-time-select :value="event.hMinTakeResa" @input="changeThenCallPopulateCT($event, 'hMinTakeResa')"
              :picker-options="{
                start: event.opening,
                step: '00:15',
                end: event.closing
              }" :clearable="false" placeholder="Select time">
            </el-time-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="event.nbServices < 2">
          <el-form-item label="Dernière heure pour la prise de réservation">
            <el-time-select :value="event.hMaxTakeResa" @input="changeThenCallPopulateCT($event, 'hMaxTakeResa')"
              :picker-options="{
                start: event.opening,
                step: '00:15',
                end: event.closing
              }" :clearable="false" placeholder="Select time">
            </el-time-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="event.nbServices < 2">
          <el-form-item label="Intervalle de réservation">
            <el-time-select :value="event.intervalResa" @input="changeThenCallPopulateCT($event, 'intervalResa')"
              :picker-options="{
                start: '00:05',
                step: '00:05',
                end: '3:00'
              }" :clearable="false" placeholder="Select time">
            </el-time-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="event.nbServices < 2">
          <el-form-item label="Limite entre réservations">
            <el-time-select :value="event.limitSecuChrono" @input="changeSimple($event, 'limitSecuChrono')"
              :picker-options="{
                start: '00:15',
                step: '00:15',
                end: '2:00'
              }" :clearable="false" placeholder="Select time">
            </el-time-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Nombre min de personnes par résa">
            <el-input-number :value="event.nbMinByResa" @input="changeSimple($event, 'nbMinByResa')" :min="1"
              :max="100"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Nombre max de personnes par résa">
            <el-input-number :value="event.nbMaxByResa" @input="changeSimple($event, 'nbMaxByResa')" :min="1"
              :max="100"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Limite avant annulation">
            <el-time-select :value="event.limitAnnulation" @input="changeSimple($event, 'limitAnnulation')"
              :picker-options="{
                start: '00:00',
                step: '01:00',
                end: '72:00'
              }" :clearable="false" placeholder="Select time">
            </el-time-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Nombre max de résa pour le service">
            <el-input-number :value="event.nbMaxResa" @input="changeSimple($event, 'nbMaxResa')" :min="0"
              :max="9999"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="min-height:70px">
          <el-form-item label="Service visible à la réservation en ligne" style="text-align:center">
            <el-switch v-model="visible" active-color="#00cec0" inactive-color="#e95d5d">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Fermeture automatique" style="text-align:center">
            <el-switch v-model="event.closeAuto" active-color="#00cec0" inactive-color="#e95d5d">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="event.closeAuto">
          <el-form-item label="Delai avant fermeture automatique">
            <el-time-select :value="event.closeAutoTime" @input="changeSimple($event, 'closeAutoTime')" :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '72:00'
            }" :clearable="false" placeholder="Select time">
            </el-time-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Caution ou prépaiement" style="text-align:center">
            <el-switch v-model="event.cashOn" active-color="#00cec0" inactive-color="#e95d5d">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="event.cashOn">
          <el-form-item label="Type" style="text-align:center">
            <el-select v-model="event.cashType" placeholder="Type">
              <el-option label="Caution" value="caution"></el-option>
              <el-option label="Prépaiement" value="prepaiement"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="event.cashOn">
          <el-form-item label="Prix / couverts" style="text-align:center">
            <el-input class="inputEuro" placeholder="Prix / couverts" v-model="event.cashPrice"
              @change="replaceV()"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="event.cashOn">
          <el-form-item label="Couverts min." style="text-align:center">
            <el-input class="inputCouv" placeholder="couverts min." v-model="event.cashCouv"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row v-loading="loading">
      <el-col :span="7" :offset="9">
        <el-button class="dark" type="primary" @click="closeDialog()">Annuler</el-button>
      </el-col>
      <el-col :span="7" :offset="1">
        <el-button type="primary" @click="validModifications()">Valider</el-button>
      </el-col>
    </el-row>
    <el-dialog title="Chevauchement détecté" :visible.sync="showOverlapDialog" width="30%"
      :before-close="handleDialogClose">
      <el-row>
        <el-col :span="24" style="margin-bottom: 20px;">
          L'événement que vous créez est programmé en même temps que des services existants. Voulez-vous fermer les
          services concernés ?
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="7" :offset="9">
          <el-button class="dark" type="primary" @click="cancelOverlap">Non</el-button>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-button type="primary" @click="confirmOverlap">Oui</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { Notification } from 'element-ui'
import cloneDeep from 'lodash/cloneDeep'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { arrayOfTimestampCheckDays, compareTime, nextTime, parseTime } from '../../tools/timeTool'

import Vue from 'vue'

export default {
  name: 'EventEdit',
  data() {
    return {
      dates: {},
      daySelected: [],
      name: '',
      title: '',
      desc: '',
      visible: false,
      event: {
        opening: '12:00',
        closing: '14:00',
        capacity: 50,
        capacityIntervalMain: 0,
        capacityIntervalTab: [],
        hMaxTakeResa: '14:00',
        hMinTakeResa: '12:00',
        intervalResa: '00:30',
        limitSecuChrono: '00:30',
        limitAnnulation: '00:00',
        nbServices: 1,
        lenghtService: '01:30',
        nbMaxByResa: 12,
        nbMinByResa: 1,
        visible: false,
        nbMaxResa: 0,
        closeAuto: false,
        closeAutoTime: '',
        cashOn: false,
        cashType: '',
        cashPrice: null,
        cashCouv: null
      },
      showOverlapDialog: false,
      isEditing: false,
      overlappingServices: [],
      loading: false,
      labelDays: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche']
    }
  },
  computed: {
    ...mapGetters({
      isVisibleDialogEditEvent: 'displayer/isVisibleDialogEditEvent',
      getNumberOfIntervalEventsDyna: 'events/getNumberOfIntervalEventsDyna',
      getSelectedEvent: 'events/getSelectedEvent',
      getUidPublic: 'newUsers/getUidPublic',
      getSubServicesForDay: 'newServices/getSubServicesForDay'
    }),
    getLink: function () {
      if (!this.getSelectedEvent || !this.getSelectedEvent.id) return ''
      let host = `http://${window.location.hostname}`
      return `${host}/event-new/${this.getUidPublic}/${this.getSelectedEvent.id}`
    }
  },
  methods: {
    ...mapActions({
      createEvent: 'events/createEvent',
      createLockedServices: 'newServices/createLockedServices'
    }),
    ...mapMutations({
      setDialogEditEvent: 'displayer/setDialogEditEvent',
      setSelectedEvent: 'displayer/setSelectedEvent',
      clearSelectedEvent: 'events/clearSelectedEvent'
    }),
    cancelOverlap() {
      this.showOverlapDialog = false
      this.finalizeEventCreation()
    },
    confirmOverlap() {
      this.showOverlapDialog = false
      this.createLockedServicesForOverlap()
      this.finalizeEventCreation()
    },
    createLockedServicesForOverlap() {
      this.overlappingServices.forEach(({ day, service }) => {
        let tsLocked = arrayOfTimestampCheckDays(this.dates[0], this.dates[1], service.idDay)
        this.createLockedServices({
          days: tsLocked,
          service: service.name
        }).then(() => {
        }).catch((err) => {
          console.error(err)
        })
      })
    },
    handleDialogClose(done) {
      this.showOverlapDialog = false
      this.finalizeEventCreation()
      done()
    },

    replaceV() {
      this.event.cashPrice = this.event.cashPrice.replace(',', '.')
    },
    cleanDays() {
      this.daySelected = []
    },
    haveCapacityMin() {
      const openingHour = parseTime(this.event.opening)
      const minTakeHour = parseTime(this.event.hMinTakeResa)

      return this.event.capacityIntervalTab && this.event.capacityIntervalTab.length > 0 &&
        minTakeHour.hours === openingHour.hours && minTakeHour.minutes === openingHour.minutes
    },
    haveCapacityMax() {
      const closingHour = parseTime(this.event.closing)
      const maxTakeHour = parseTime(this.event.hMaxTakeResa)

      return this.event.capacityIntervalTab && this.event.capacityIntervalTab.length > 0 &&
        maxTakeHour.hours === closingHour.hours && maxTakeHour.minutes === closingHour.minutes
    },
    finalizeEventCreation() {
      this.closeDialog()
      Notification.success({
        title: 'Événement sauvegardé',
        message: this.name,
        position: 'bottom-right'
      })
    },
    validModifications: function () {
      this.createEvent({
        name: this.name,
        title: this.title,
        desc: this.desc,
        visible: this.visible,
        days: this.daySelected,
        dates: this.dates,
        services: this.event
      }).then((res) => {
        // if visible check if classic service overlap
        if (res.visible) {
          let overlapping = false
          let overlappingServices = []

          res.days.forEach(day => {
            let checkNormalServices = this.getSubServicesForDay(day)
            checkNormalServices.forEach(nService => {
              if (nService.type !== 'event') {
                if (
                  (compareTime(this.event.opening, nService.opening) <= 0 && compareTime(this.event.closing, nService.opening) > 0) ||
                  (compareTime(this.event.opening, nService.closing) < 0 && compareTime(this.event.closing, nService.closing) >= 0) ||
                  (compareTime(this.event.opening, nService.opening) >= 0 && compareTime(this.event.closing, nService.closing) <= 0) ||
                  (compareTime(this.event.opening, nService.opening) <= 0 && compareTime(this.event.closing, nService.closing) >= 0)
                ) {
                  overlapping = true
                  overlappingServices.push({ day, service: nService })
                }
              }
            })
          })
          if (overlapping) {
            this.overlappingServices = overlappingServices
            this.showOverlapDialog = true
          } else {
            this.finalizeEventCreation()
          }
        } else {
          this.finalizeEventCreation()
        }
      }).catch(err => {
        Notification.error({
          title: 'Erreur',
          message: err.message,
          position: 'bottom-right'
        })
        console.error(err)
      })
    },
    closeDialog: function () {
      this.loading = false
      this.setDialogEditEvent(false)
      this.clearSelectedEvent()
    },
    initEventData: function () {
      if (this.getSelectedEvent) {
        this.isEditing = true
        this.name = this.getSelectedEvent.name
        this.title = this.getSelectedEvent.title
        this.desc = this.getSelectedEvent.desc
        this.visible = this.getSelectedEvent.visible
        this.daySelected = cloneDeep(this.getSelectedEvent.days)
        this.dates = cloneDeep(this.getSelectedEvent.dates)
        this.event = cloneDeep(this.getSelectedEvent.services[this.getSelectedEvent.days[0]])
      } else {
        this.isEditing = false
        this.dates = {}
        this.daySelected = []
        this.name = ''
        this.title = ''
        this.desc = ''
        this.visible = false
        this.event = {
          opening: '12:00',
          closing: '14:00',
          capacity: 50,
          capacityIntervalMain: 0,
          capacityIntervalTab: [],
          hMaxTakeResa: '14:00',
          hMinTakeResa: '12:00',
          intervalResa: '00:30',
          limitSecuChrono: '00:30',
          limitAnnulation: '00:00',
          nbServices: 1,
          lenghtService: '01:30',
          nbMaxByResa: 12,
          nbMinByResa: 1,
          invisible: false,
          nbMaxResa: 0,
          closeAuto: false,
          closeAutoTime: '',
          cashOn: false,
          cashType: '',
          cashPrice: null,
          cashCouv: null
        }
      }
    },
    changeThenCallInputInit(event, key) {
      if (event && (event !== '' || event !== ' ')) {
        Vue.set(this.event, key, event)
      }
      this.setOverInputInit()
    },
    changeThenCallPopulateCT(event, key) {
      if ((event || event === 0) && (event !== '' || event !== ' ')) {
        Vue.set(this.event, key, event)
      }
      this.populateCapacityTab()
    },
    changeSimple(event, key) {
      if ((event || event === 0) && (event !== '' || event !== ' ')) {
        Vue.set(this.event, key, event)
      }
    },
    checkIntervalNull(id) {
      if (this.event.capacityIntervalTab[id].capacity === undefined) this.event.capacityIntervalTab[id].capacity = 0
      this.updateCapacityTab()
    },
    checkHoursValidity: function () {
      let open = parseTime(this.event.opening)
      let close = parseTime(this.event.closing)
      let max = parseTime(this.event.hMaxTakeResa)
      let min = parseTime(this.event.hMinTakeResa)
      // cas ou l'ouverture est plus grande que la fermeture
      if (open.hours > close.hours || (open.hours === close.hours && open.minutes > close.minutes)) {
        this.setOverInputInit()
      }
      // cas ou l'ouverture est plus grande que la première heure de prise de resa
      if (open.hours > min.hours || (open.hours === min.hours && open.minutes > min.minutes)) {
        this.event.hMinTakeResa = this.event.opening
      }
      // cas ou la dernière heure de prise de resa est plus grande que la fermeture
      if (max.hours > close.hours || (max.hours === close.hours && max.minutes > close.minutes)) {
        this.event.hMaxTakeResa = this.event.closing
      }
      // cas ou la première heure de prise de resa est plus grande que la dernière heure de prise de resa
      if (min.hours > max.hours || (min.hours === max.hours && min.minutes > max.minutes)) {
        this.event.hMinTakeResa = this.event.hMaxTakeResa
      }
    },
    setOverInputInit: function () {
      let openTime = parseTime(this.event.opening)
      let minTakeResaTime = parseTime(this.event.hMinTakeResa)
      let correct = minTakeResaTime.hours > openTime.hours || (minTakeResaTime.hours === openTime.hours && minTakeResaTime.minutes > openTime.minutes)
      if (this.event.opening && !correct) {
        this.event.hMinTakeResa = this.event.opening
        let tmp = nextTime(this.event.opening, this.event.lenghtService)
        this.event.closing = tmp
        this.event.hMaxTakeResa = tmp
      }
      this.populateCapacityTab()
    },
    populateCapacityTab: function () {
      // first check hours
      this.checkHoursValidity()
      let tmp = []
      // first
      tmp.push({
        id: 0,
        hour: this.event.opening,
        capacity: this.event.capacityIntervalMain
      })
      this.getNumberOfIntervalEventsDyna(this.event).forEach(interval => {
        tmp.push({
          id: interval.id,
          hour: interval.hour,
          capacity: this.event.capacityIntervalMain
        })
      })
      // last
      tmp.push({
        id: tmp.length,
        hour: this.event.closing,
        capacity: this.event.capacityIntervalMain
      })
      this.event.capacityIntervalTab = tmp.slice(0)
    },
    updateCapacityTab: function () {
      let tmp = []
      // first
      tmp.push({
        id: 0,
        hour: this.event.opening,
        capacity: this.event.capacityIntervalTab[0].capacity
      })
      this.getNumberOfIntervalEventsDyna(this.event).forEach(interval => {
        tmp.push({
          id: interval.id,
          hour: interval.hour,
          capacity: this.event.capacityIntervalTab[interval.id].capacity
        })
      })
      // last
      tmp.push({
        id: tmp.length,
        hour: this.event.closing,
        capacity: parseInt(this.event.capacityIntervalTab[tmp.length].capacity)
      })
      this.event.capacityIntervalTab = tmp.slice(0)
    }
  },
  created: function () {
    this.initEventData()
  },
  watch: {
    'isVisibleDialogEditEvent': function (val, oldVal) {
      if (val === true) {
        this.initEventData()
      }
    }
  }
}
</script>

<style lang="scss">
.dateChooser {
  margin-bottom: 30px;
}

.cashOption {
  .el-input {
    width: 80%;
    margin: auto;
  }
}

.eventName {
  margin: auto;
  display: block;
}

.el-checkbox-group {
  text-align: center;
}

.el-checkbox-button {
  &__inner {
    color: var(--color_light_grey);
    background-color: var(--dark__line_color-light);
    border: 1px solid var(--dark__main_color-dark) !important;

    &:hover {
      color: var(--color_blue_azure);
    }
  }

  &.is-checked .el-checkbox-button__inner {
    color: var(--dark__main_color-dark);
    background-color: var(--color_blue_azure);
    border: 1px solid var(--dark__main_color-dark);
    box-shadow: inherit;
  }
}

.screen-fake-input {
  margin-bottom: 20px;
  text-align: center;
}
</style>
